import { IconRegularClock, Ratings } from '@notino/react-styleguide'
import React from 'react'
import { useIntl } from 'react-intl'
import useMessages from '../../../../hooks/useMessages'
import { /* LoyaltyConfigResponse */ OpeningHoursData, Ratings as RatingsData } from '../../../../types/types'
import * as SC from './ProfiSalonHeaderStyles'
import { getViewOnMapEvent } from '../../../../utils/dataLayerEvents'
import { pushToDataLayer } from '../../../../utils/dataLayer'
import { formatRating } from '../../../../utils/helper'
import VisuallyHidden from '../../../../atoms/VisuallyHidden/VisuallyHidden'
// import LoyaltyIcon from '../../../../assets/icons/LoyaltyIcon'

type Props = {
	ratingId: string
	ratingsData: RatingsData
	name?: string
	address?: string
	logoUrl?: string
	openingHoursData?: OpeningHoursData
	googleMapLink?: string
	// loyaltyConfigData: LoyaltyConfigResponse
}

const ProfiSalonHeader = (props: Props) => {
	const { ratingId, ratingsData, name, address, googleMapLink, logoUrl, openingHoursData /* loyaltyConfigData */ } = props

	const { messages } = useMessages()
	const intl = useIntl()

	const ratingAccessibleText =
		ratingsData.rating !== undefined
			? intl.formatMessage(
					{
						id: 'Average rating: {rating} out of 5, {reviewCount, plural, one {# review} other {# reviews}}',
						defaultMessage: 'Average rating: {rating} out of 5, {reviewCount, plural, one {# review} other {# reviews}}'
					},
					{
						rating: formatRating(intl, ratingsData.rating),
						reviewCount: ratingsData.ratesCount
					}
				)
			: undefined

	return (
		<SC.Container>
			<SC.NameAndLogoContainer>
				{logoUrl && (
					<SC.LogoWrapper>
						<SC.Logo loading='lazy' alt={'logo'} src={logoUrl} />
					</SC.LogoWrapper>
				)}
				{name && <SC.Name>{name}</SC.Name>}
			</SC.NameAndLogoContainer>
			<SC.AdditionalInfoContainer>
				{ratingsData.ratesCount > 0 && ratingsData.rating !== undefined && ratingAccessibleText && (
					<SC.RatingsContainer>
						<VisuallyHidden>{ratingAccessibleText}</VisuallyHidden>
						<Ratings
							size={16}
							foreground={'text.primary'}
							background={'icon.disabled'}
							rating={ratingsData.rating}
							ratingId={ratingId}
							aria-hidden={'true'}
						/>
						<SC.AverageRatingValue aria-hidden={'true'}>{formatRating(intl, ratingsData.rating)}</SC.AverageRatingValue>
						<SC.RatingsCount aria-hidden={'true'}>({ratingsData.ratesCount})</SC.RatingsCount>
					</SC.RatingsContainer>
				)}
				{openingHoursData && (
					<SC.OpeningHours>
						{!openingHoursData.isOpen && <IconRegularClock color={'icon.primary'} width={'1rem'} height={'1rem'} />}
						<SC.OpeningHoursMessage dangerouslySetInnerHTML={{ __html: openingHoursData.message }} />
					</SC.OpeningHours>
				)}

				{address && (
					<SC.Address>
						{address}
						{googleMapLink && (
							<SC.ShowOnMapLink
								href={googleMapLink}
								target={'_blank'}
								rel={'nofollow noopener noreferrer'}
								onClick={() => {
									const event = getViewOnMapEvent({ interaction: 'text_header' })
									pushToDataLayer(event)
								}}
							>
								{messages['Show on map']}
							</SC.ShowOnMapLink>
						)}
					</SC.Address>
				)}
			</SC.AdditionalInfoContainer>
			{/* // NOTE: Loyalty program is currently hidden */}
			{/* {loyaltyConfigData.loyaltySalonDetail.loyalty.showLoyalty && ( */}
			{/*	<SC.LoyaltyProgram> */}
			{/*		<SC.LoyaltyIconWrapper> */}
			{/*			<LoyaltyIcon /> */}
			{/*		</SC.LoyaltyIconWrapper> */}
			{/*		<SC.LoyaltyText dangerouslySetInnerHTML={{ __html: loyaltyConfigData.loyaltySalonDetail.loyalty.text }} /> */}
			{/*	</SC.LoyaltyProgram> */}
			{/* )} */}
		</SC.Container>
	)
}

export default ProfiSalonHeader
